import type { TLBaseShape } from "@tldraw/tlschema";
/**
 * The gridline construction shape: an infinite axis-aligned dash-dot line
 * with a label bubble. The set of gridline shapes on a page IS the Bear grid.
 *
 * Position rides the shape's own x/y: an `axis: "x"` gridline is a vertical
 * line at the shape's x (its y is ignored); an `axis: "y"` gridline is a
 * horizontal line at the shape's y.
 */
import { T } from "@tldraw/validate";

export interface GridlineProps {
  axis: "x" | "y";
  label: string;
}

declare module "@tldraw/tlschema" {
  interface TLGlobalShapePropsMap {
    gridline: GridlineProps;
  }
}

export type GridlineShape = TLBaseShape<"gridline", GridlineProps>;

export const gridlineProps: Record<keyof GridlineProps, T.Validatable<any>> = {
  axis: T.literalEnum("x", "y"),
  label: T.string,
};
